import { Navigate, Outlet } from 'react-router-dom';
import { useCommunityContext } from '@/providers/community-context';
import { useUser } from '@/hooks/use-user';
import { resolveCommunityLandingPath } from '@/lib/community-navigation';
import type { CommunityKind } from '@/types';

interface CommunityKindRouteProps {
  allowedKinds: CommunityKind[];
}

export function CommunityKindRoute({ allowedKinds }: CommunityKindRouteProps) {
  const { community } = useCommunityContext();
  const { user } = useUser();
  const kind = community.kind ?? 'COMMUNITY';

  if (!allowedKinds.includes(kind)) {
    return <Navigate to={resolveCommunityLandingPath(community, user)} replace />;
  }

  return <Outlet />;
}
